export default __webpack_public_path__ + "static/studentdiscount-d362c745e69da7f721c6a92edd7c4b39.png";